<form [formGroup]="form" (submit)="submit()">
  <div class="form-group row">
    <label for="name" class="col-sm-2 col-form-label">Name</label>
    <div class="col-sm-10">
      <input type="text" class="form-control" formControlName="name" name="name" id="name">
    </div>
  </div>

  <div class="form-group row" formArrayName="permissions">
    <label class="col-sm-2 col-form-label">Permissions</label>
    <div class="col-sm-10">
      <div class="form-check form-check-inline col-3" *ngFor="let permission of permissions; let i = index" [formGroupName]="i">
        <input class="form-check-input" type="checkbox" formControlName="value">
        <label class="form-check-label">{{permission.name}}</label>
      </div>
    </div>
  </div>

  <button class="btn btn-outline-secondary">Save</button>
</form>
